<template>
    <base-form-control v-bind="formControlAttributes">
        <slot name="prepend"></slot>
        <date-picker v-bind="controlAttributes" v-on="listeners" :disabled="disabled" class="control" v-model="model" :valueType="valueType" :format="format" :type="type" />
        <slot name="append"></slot>
    </base-form-control>
</template>

<script>
import BaseFormControl from './BaseFormControl';
import BaseInput from './BaseInput';
import DatePicker from 'vue2-datepicker';

export default {
    allowedControlAttributeNames : ['disabledTime', 'disabledDate', 'defaultPanel'],

    props : {
        'default-panel' : { type : String, default : '' },
        'disabled-time' : { type : [String, Function], default : '' },
        'disabled-date' : { type : [String, Function], default : '' },
        format          : { type : String, default : 'DD/MM/YYYY' },
        valueType       : { type : String, default : 'format' }
    },
    data () { return { type : 'date' }; },
    name       : 'form-date-picker',
    components : { BaseFormControl, 'date-picker' : DatePicker },
    extends    : BaseInput,
    methods    : {
        updateValue () {
            this.$emit('input', this.model);
        }
    }
};
</script>
